// Highlight baris tabel yang diklik, untuk SEMUA tabel di aplikasi.
// Dipasang sekali di main.js: klik di baris <tbody> -> baris itu ditandai (class "row-selected"),
// baris lain di tabel yang SAMA dilepas (tabel lain, mis. tabel di dalam modal, tidak terpengaruh).
// Klik baris yang sama lagi -> highlight dilepas.
//
// Banyak tabel memakai :key="index", jadi elemen <tr> dipakai ulang saat data berganti
// (ganti halaman, filter, simpan). Supaya highlight tidak "pindah" ke data lain,
// highlight otomatis dilepas begitu isi baris yang ditandai berubah.

const SELECTED = 'row-selected';
const observers = new WeakMap();

function clear(row) {
  if (!row) return;
  row.classList.remove(SELECTED);
  const observer = observers.get(row);
  if (observer) {
    observer.disconnect();
    observers.delete(row);
  }
}

// lepas highlight kalau isi baris berubah (data baru dirender di <tr> yang sama) atau barisnya dihapus
function watch(row) {
  const snapshot = row.textContent;
  const observer = new MutationObserver(() => {
    if (!row.isConnected || row.textContent !== snapshot) {
      clear(row);
    }
  });
  observer.observe(row.parentNode || row, { childList: true, subtree: true, characterData: true });
  observers.set(row, observer);
}

function onClick(event) {
  const row = event.target.closest ? event.target.closest('tbody tr') : null;
  if (!row || !row.closest('table')) return;
  // baris kosong / "Memuat data..." (satu sel colspan) tidak perlu ditandai
  if (row.cells.length === 1 && row.cells[0].colSpan > 1) return;

  const tbody = row.parentNode;
  if (row.classList.contains(SELECTED)) {
    // klik tombol/ikon/input di dalam baris jangan melepas highlight
    if (event.target.closest('a, button, input, select, textarea, i, .badge')) return;
    clear(row);
    return;
  }

  tbody.querySelectorAll(':scope > tr.' + SELECTED).forEach(clear);
  row.classList.add(SELECTED);
  watch(row);
}

export default {
  install(app, options = {}) {
    document.addEventListener('click', onClick, true);
    // pindah halaman -> lepas semua highlight
    if (options.router) {
      options.router.afterEach(() => document.querySelectorAll('tr.' + SELECTED).forEach(clear));
    }
  },
};
